import { Skill } from "../interfaces/Skill";

export const technicalSkills: Skill[] = [
	{
		id: 1,
		skillName: "Java - Spring Boot",
		skillData: "I Am Java Developer",
		skillDetails: [
			{ id: 1, data: "Building scalable and high-performance secure web applications using Java Spring Boot" },
			{ id: 2, data: "Implementing RESTful APIs for seamless communication between different components" },
			{ id: 3, data: "Optimizing and fine-tuning Java applications for improved efficiency" },
		],
	},
	{
		id: 2,
		skillName: "Flutter",
		skillData: "I Am Flutter Developer",
		skillDetails: [
			{ id: 1, data: "Creating cross-platform mobile applications with a beautiful and responsive user interface" },
			{ id: 2, data: "Implementing complex animations and transitions for a delightful user experience" },
			{ id: 3, data: "Integrating Flutter applications with backend services for seamless data flow" },
		],
	},
	{
		id: 3,
		skillName: "React (Js / Ts)",
		skillData: "I Am React Developer",
		skillDetails: [
			{ id: 1, data: "Building interactive and dynamic user interfaces with React" },
			{ id: 2, data: "Working with state management libraries like Redux for efficient data flow" },
			{ id: 3, data: "Optimizing web applications for performance and responsiveness" },
		],
	},
	{
		id: 4,
		skillName: "Ruby on Rails",
		skillData: "I Am Ruby on Rails Developer",
		skillDetails: [
			{ id: 1, data: "Developing robust and scalable web applications using the Ruby on Rails framework" },
			{ id: 2, data: "Implementing RESTful APIs and integrating third-party services" },
			{ id: 3, data: "Utilizing ActiveRecord for efficient database interactions" },
		],
	},
	{
		id: 5,
		skillName: "SQL Database",
		skillData: "I Am Proficient in SQL Database (MS SQL Server/Postgres/ MySQL)",
		skillDetails: [
			{ id: 1, data: "Designing normalized database schemas for efficient data storage and retrieval" },
			{ id: 2, data: "Optimizing SQL queries for better performance and resource utilization" },
			{ id: 3, data: "Implementing database security measures to protect sensitive data" },
		],
	},
];
